import Immutable from 'immutable';
export default (props) => {
  const { $$data } = props;
  if ($$data === undefined) {
    // console.error('Missing $$data');
    return Immutable.fromJS([]);
  }
  return $$data !== undefined &&
    $$data.get('mypastevents') !== undefined &&
    $$data.get('mypastevents').size > 0
    ? $$data
        .get('mypastevents')
        .filter(
          ($e) =>
            $e.get('hasAttended') !== undefined &&
            $e.get('hasAttended') !== '' &&
            $e.get('hasAttended') !== null,
        )
        .get(0)
    : undefined;
};



// WEBPACK FOOTER //
// ./src/helpers/getMyPastEvents.jsx